module.exports = new __parcel__URL__("somethings-wrong.ef47b20e.png").toString();